export const credibilityStats = [
  { label: "Produção Própria", value: "100", suffix: "%" },
  { label: "Sabores de Sanduíches", value: "9", suffix: "" },
  { label: "Frentes de Atuação", value: "3", suffix: "" },
  { label: "Clientes Atendidos", value: "+ de 1000", suffix: "" },
];

export const credibilityBadges = [
  { icon: "ri-time-line", text: "Desde 2005" },
  { icon: "ri-restaurant-line", text: "9 sabores de sanduíches" },
  { icon: "ri-store-2-line", text: "Atacado e varejo" },
  { icon: "ri-cup-line", text: "Coffee Breaks" },
  { icon: "ri-calendar-event-line", text: "Eventos corporativos" },
  { icon: "ri-group-line", text: "Milhares de clientes" },
  { icon: "ri-seedling-line", text: "Ingredientes selecionados" },
  { icon: "ri-shield-check-line", text: "Segurança alimentar" },
  { icon: "ri-building-2-line", text: "Produção própria" },
  { icon: "ri-truck-line", text: "Entrega confiável" },
];